import { formatters } from 'services';

type OptionSecondaryMetricInput = {
  underlyingKind?: 'EQUITY' | 'BOND';
  annualizedImpliedVolatility: number | string | null;
  annualizedImpliedVolatilityDiff?: number | string | null;
  basisPoints: number | string | null;
  basisPointsDiff?: number | string | null;
};

export const optionSecondaryMetric = ({
  underlyingKind,
  annualizedImpliedVolatility,
  annualizedImpliedVolatilityDiff,
  basisPoints,
  basisPointsDiff,
}: OptionSecondaryMetricInput) => {
  if (underlyingKind === 'BOND') {
    return {
      label: 'BP',
      value: basisPoints == null ? '—' : formatters.commas2Digits(basisPoints),
      priceDiff: basisPointsDiff,
    };
  }

  return {
    label: 'IV',
    value:
      annualizedImpliedVolatility == null
        ? '—'
        : formatters.percent2Digit(annualizedImpliedVolatility),
    priceDiff: annualizedImpliedVolatilityDiff,
  };
};
